export const ordersTypes = {
    GET_DATA_REQUEST: 'Get orders data - request',
    GET_DATA_SUCCESS: 'Get orders data - success',
    GET_DATA_FAIL: 'Get orders data - Fail',

    GET_ORDER_REQUEST: 'Get single order data - request',
    GET_ORDER_SUCCESS: 'Get single order data - success',
    GET_ORDER_FAIL: 'Get single order data - Fail',

    CLEAR: 'Clear orders',
};
